import { render, staticRenderFns } from "./GatTimeEdit.vue?vue&type=template&id=36ec937b&scoped=true"
import script from "./GatTimeEdit.vue?vue&type=script&lang=js"
export * from "./GatTimeEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ec937b",
  null
  
)

export default component.exports